<template>
    <div class="panel-body">
        <HeaderGeneral :vista="'Recepción de Retiros Independientes'" :ruta="'- Retiros Independientes'" :carpeta="'Prestadores'" />
        <hr class="my-4">

        <!-- Tabs — un estado por tab para filtrado server-side limpio -->
        <b-tabs v-model="tabActivo" class="mb-3" @input="onTabChange">
            <b-tab v-for="tab in tabs" :key="tab.estado">
                <template #title>
                    {{ tab.label }}
                    <b-badge pill :style="tab.estilo" class="ml-1">{{ conteos[tab.estado] || 0 }}</b-badge>
                </template>
            </b-tab>
        </b-tabs>

        <b-row class="mb-3" align-v="center">
            <!-- Buscador estilo Table.vue: campo + valor + botón -->
            <b-col md="3">
                <b-form-select v-model="buscarCampo" :options="opcionesBusqueda" @change="onCampoChange" />
            </b-col>
            <b-col md="3">
                <b-form-input
                    v-model="buscarValor"
                    placeholder="Valor a buscar..."
                    :disabled="!buscarCampo"
                    @keyup.enter="buscar"
                />
            </b-col>
            <b-col md="auto">
                <b-button variant="primary" :disabled="!buscarCampo || !buscarValor.trim()" @click="buscar">
                    <b-icon icon="search" /> Buscar
                </b-button>
                <b-button variant="outline-secondary" class="ml-1" @click="limpiarBusqueda">
                    Limpiar
                </b-button>
            </b-col>
            <b-col md="2">
                <b-form-select v-model="porPagina" :options="opcionesPorPagina" @change="onPorPaginaChange" />
            </b-col>
            <b-col class="text-right">
                <span class="text-muted small mr-2">{{ totalRegistros }} registro(s)</span>
                <b-button variant="outline-primary" size="sm" @click="cargarRetiros">
                    <b-icon icon="arrow-clockwise" />
                </b-button>
            </b-col>
        </b-row>

        <b-overlay :show="cargando" rounded="sm">
            <b-table
                :items="registros"
                :fields="campos"
                responsive striped hover show-empty
                :empty-text="tabActual.emptyText"
            >
                <template #cell(paciente)="row">
                    <strong>{{ row.item.data.nombre_completo || '-' }}</strong><br>
                    <small class="text-muted">
                        {{ tipoDocNombre(row.item.data.tipo_documento) }} {{ row.item.data.documento }}
                    </small>
                </template>
                <template #cell(ubicacion)="row">
                    {{ row.item.data.barrio }}<br>
                    <small>{{ municipioNombre(row.item.data.municipio) }}, {{ departamentoNombre(row.item.data.departamento) }}</small>
                </template>
                <template #cell(equipos)="row">
                    <b-badge
                        v-for="id in (row.item.data.elementos_retiro || [])"
                        :key="id"
                        variant="light"
                        class="mr-1 border text-dark"
                    >{{ elementoNombre(id) }}</b-badge>
                </template>
                <template #cell(estado)="row">
                    <b-badge :style="estiloEstado(row.item.data.estado)">
                        {{ nombreEstado(row.item.data.estado) }}
                    </b-badge>
                </template>
                <template #cell(acciones)="row">
                    <b-button variant="outline-info" size="sm" class="mr-1" @click="verDetalle(row.item)">
                        <b-icon icon="eye" /> Ver
                    </b-button>
                    <b-button
                        v-if="row.item.data.estado == 1 || row.item.data.estado == 15"
                        variant="outline-success" size="sm"
                        @click="abrirAsignacion(row.item)"
                    >
                        <b-icon icon="person-check" />
                        {{ row.item.data.estado == 15 ? 'Reasignar' : 'Asignar' }}
                    </b-button>
                </template>
            </b-table>

            <b-pagination
                v-model="paginaActual"
                :total-rows="totalRegistros"
                :per-page="porPagina"
                align="center"
                @change="onPaginaChange"
            />
        </b-overlay>

        <!-- ── Modal Detalle ── -->
        <b-modal v-model="modalDetalle" :title="'Detalle Retiro N° ' + (seleccionado ? seleccionado.data.id : '')" size="lg" ok-only ok-title="Cerrar" header-bg-variant="light">
            <div v-if="seleccionado">
                <b-row class="mb-3">
                    <b-col md="6">
                        <h6 class="font-weight-bold border-bottom pb-1 mb-2">Paciente</h6>
                        <p class="mb-1"><span class="text-muted">Nombre:</span> <strong>{{ seleccionado.data.nombre_completo || '-' }}</strong></p>
                        <p class="mb-1"><span class="text-muted">Documento:</span> {{ tipoDocNombre(seleccionado.data.tipo_documento) }} {{ seleccionado.data.documento }}</p>
                        <p class="mb-1"><span class="text-muted">Teléfono:</span> {{ seleccionado.data.telefono_1 }}</p>
                        <p class="mb-1"><span class="text-muted">Contacto:</span> {{ seleccionado.data.nombre_contacto || '-' }}</p>
                        <p class="mb-1"><span class="text-muted">Correo:</span> {{ seleccionado.data.email || '-' }}</p>
                    </b-col>
                    <b-col md="6">
                        <h6 class="font-weight-bold border-bottom pb-1 mb-2">Ubicación del Retiro</h6>
                        <p class="mb-1"><span class="text-muted">Barrio:</span> {{ seleccionado.data.barrio || '-' }}</p>
                        <p class="mb-1"><span class="text-muted">Municipio:</span> {{ municipioNombre(seleccionado.data.municipio) }}</p>
                        <p class="mb-1"><span class="text-muted">Departamento:</span> {{ departamentoNombre(seleccionado.data.departamento) }}</p>
                    </b-col>
                </b-row>
                <h6 class="font-weight-bold border-bottom pb-1 mb-2">Equipos a Retirar</h6>
                <div class="mb-3">
                    <b-badge v-for="id in (seleccionado.data.elementos_retiro || [])" :key="id" variant="light" class="mr-2 mb-1 p-2 border text-dark" style="font-size:0.85rem">
                        {{ elementoNombre(id) }}
                    </b-badge>
                    <span v-if="!seleccionado.data.elementos_retiro || !seleccionado.data.elementos_retiro.length" class="text-muted">Sin equipos</span>
                </div>
                <h6 class="font-weight-bold border-bottom pb-1 mb-2">Estado del Proceso</h6>
                <b-table-simple small bordered class="mb-0">
                    <b-tbody>
                        <b-tr><b-td class="text-muted" style="width:40%">Estado actual</b-td><b-td><b-badge :style="estiloEstado(seleccionado.data.estado)">{{ nombreEstado(seleccionado.data.estado) }}</b-badge></b-td></b-tr>
                        <b-tr><b-td class="text-muted">Fecha creación</b-td><b-td>{{ formatFecha(seleccionado.data.createat) }}</b-td></b-tr>
                        <b-tr><b-td class="text-muted">Fecha asignación</b-td><b-td>{{ formatFecha(seleccionado.data.fecha_asignacion) || '-' }}</b-td></b-tr>
                        <b-tr><b-td class="text-muted">Fecha retiro efectivo</b-td><b-td>{{ formatFecha(seleccionado.data.fecha_retiro_efectivo) || '-' }}</b-td></b-tr>
                        <b-tr v-if="seleccionado.data.motivo_no_retiro"><b-td class="text-muted">Motivo no retiro</b-td><b-td class="text-danger">{{ seleccionado.data.motivo_no_retiro }}</b-td></b-tr>
                        <b-tr v-if="seleccionado.data.observaciones_retiro"><b-td class="text-muted">Observaciones</b-td><b-td>{{ seleccionado.data.observaciones_retiro }}</b-td></b-tr>
                    </b-tbody>
                </b-table-simple>
                <h6 class="font-weight-bold border-bottom pb-1 mb-2 mt-3">Documentos adjuntos</h6>
                <AdjuntosRetiro :id-retiro="seleccionado.data.id" :solo-lectura="true" />

                <h6 class="font-weight-bold border-bottom pb-1 mb-2 mt-3">Historial de cambios</h6>
                <HistorialRetiro :id-retiro="Number(seleccionado.data.id)" />
            </div>
        </b-modal>

        <!-- ── Modal Asignar / Reasignar ── -->
        <b-modal v-model="modalAsignar" :title="(asignando && asignando.data.estado == 15 ? 'Reasignar' : 'Asignar') + ' Proveedor'" @ok="confirmarAsignacion" ok-title="Confirmar" cancel-title="Cancelar" :ok-disabled="!asignacionForm.id_proveedor || procesando">
            <b-overlay :show="procesando">
                <div v-if="asignando">
                    <b-list-group flush class="mb-3">
                        <b-list-group-item><strong>N° Solicitud:</strong> {{ asignando.data.id }}</b-list-group-item>
                        <b-list-group-item><strong>Paciente:</strong> {{ asignando.data.nombre_completo || '-' }}</b-list-group-item>
                        <b-list-group-item><strong>Dirección:</strong> {{ asignando.data.barrio }}, {{ municipioNombre(asignando.data.municipio) }}</b-list-group-item>
                    </b-list-group>
                    <b-alert v-if="asignando.data.estado == 15" show variant="warning" class="text-dark">
                        <b-icon icon="exclamation-triangle" /> El proveedor anterior no pudo realizar el retiro.<br>
                        <strong>Motivo:</strong> {{ asignando.data.motivo_no_retiro || 'Sin especificar' }}
                    </b-alert>
                    <b-form-group label="Seleccionar Proveedor *" class="mt-3">
                        <b-form-select v-model="asignacionForm.id_proveedor" :options="listaProveedores" />
                    </b-form-group>
                    <b-form-group label="Observaciones para el proveedor">
                        <b-form-textarea v-model="asignacionForm.observaciones" rows="3" />
                    </b-form-group>
                </div>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
import HeaderGeneral from "../../components/HeaderGeneral.vue";
import AdjuntosRetiro from "../../components/AdjuntosRetiro.vue";
import HistorialRetiro from "../../components/HistorialRetiro.vue";
import { OPCIONES_BUSQUEDA, buildFiltrosBusqueda } from "../Retiros/retiroBuscadorMixin.js";

const retiroRepo = RepositoryFactory.get("retiro");
const config     = RepositoryFactory.get("config");

const ESTADOS = {
    1:  { nombre: 'Pendiente asignación', style: { backgroundColor: '#f0ad4e', color: '#212529' } },
    3:  { nombre: 'Asignado a proveedor', style: { backgroundColor: '#0d6efd', color: '#ffffff' } },
    14: { nombre: 'En proceso de retiro', style: { backgroundColor: '#6f42c1', color: '#ffffff' } },
    13: { nombre: 'Retirado',             style: { backgroundColor: '#198754', color: '#ffffff' } },
    15: { nombre: 'Retiro no realizado',  style: { backgroundColor: '#dc3545', color: '#ffffff' } },
};

const TABS = [
    { estado: 1,  label: 'Pendientes',   emptyText: 'No hay retiros pendientes de asignación.', estilo: { backgroundColor:'#f0ad4e', color:'#212529' } },
    { estado: 3,  label: 'Asignados',    emptyText: 'No hay retiros asignados.',                estilo: { backgroundColor:'#0d6efd', color:'#ffffff' } },
    { estado: 14, label: 'En proceso',   emptyText: 'No hay retiros en proceso.',               estilo: { backgroundColor:'#6f42c1', color:'#ffffff' } },
    { estado: 15, label: 'Fallidos',     emptyText: 'No hay retiros fallidos.',                 estilo: { backgroundColor:'#dc3545', color:'#ffffff' } },
    { estado: 13, label: 'Completados',  emptyText: 'No hay retiros completados.',              estilo: { backgroundColor:'#198754', color:'#ffffff' } },
];

export default {
    components: { HeaderGeneral, AdjuntosRetiro, HistorialRetiro },
    data() {
        return {
            cargando: false,
            procesando: false,
            registros: [],
            totalRegistros: 0,
            paginaActual: 1,
            porPagina: 15,
            buscarCampo: null,
            buscarValor: '',
            opcionesBusqueda: OPCIONES_BUSQUEDA,
            tabActivo: 0,
            tabs: TABS,
            conteos: {},
            modalDetalle: false,
            modalAsignar: false,
            seleccionado: null,
            asignando: null,
            listaProveedores: [{ value: null, text: 'Seleccionar proveedor...' }],
            asignacionForm: { id_proveedor: null, observaciones: '' },
            tiposDocMap: {}, elementosMap: {}, departamentosMap: {}, municipiosMap: {},
            opcionesPorPagina: [
                { value: 10, text: '10 por página' },
                { value: 15, text: '15 por página' },
                { value: 25, text: '25 por página' },
                { value: 50, text: '50 por página' },
            ],
            campos: [
                { key: 'data.id',       label: 'N° Sol.', sortable: true },
                { key: 'paciente',      label: 'Paciente' },
                { key: 'ubicacion',     label: 'Ubicación' },
                { key: 'equipos',       label: 'Equipos' },
                { key: 'estado',        label: 'Estado' },
                { key: 'data.createat', label: 'Fecha', formatter: (v) => this.formatFecha(v) },
                { key: 'acciones',      label: 'Acciones' },
            ],
        };
    },
    computed: {
        tabActual() { return TABS[this.tabActivo] || TABS[0]; },
    },
    async mounted() {
        await Promise.all([this.cargarListados(), this.cargarProveedores()]);
        await this.cargarRetiros();
        this.cargarConteos();
    },
    methods: {
        // ── Carga de datos con paginación y filtros server-side ──────────────
        async cargarRetiros() {
            this.cargando = true;
            try {
                const filtros = [
                    { estado: { equals: String(this.tabActual.estado) } },
                    ...buildFiltrosBusqueda(this.buscarCampo, this.buscarValor),
                ];
                const resp = await retiroRepo.consultarRetirosIndependientes({
                    page:    this.paginaActual,
                    size:    this.porPagina,
                    filtros,
                });
                this.registros      = resp.rows;
                this.totalRegistros = resp.count;
                // Actualizar conteo del tab activo
                this.$set(this.conteos, this.tabActual.estado, resp.count);
            } catch (e) {
                this.registros = [];
                this.totalRegistros = 0;
            } finally {
                this.cargando = false;
            }
        },

        async cargarConteos() {
            try {
                const datos = await retiroRepo.contarRetirosIndependientesPorEstado([]);
                const nuevos = {};
                TABS.forEach(t => { nuevos[t.estado] = datos[String(t.estado)] || 0; });
                this.conteos = nuevos;
            } catch (e) { /* mantener conteos anteriores */ }
        },

        // ── Eventos de UI ────────────────────────────────────────────────────
        buscar() {
            if (!this.buscarCampo || !this.buscarValor.trim()) return;
            this.paginaActual = 1;
            this.cargarRetiros();
        },
        limpiarBusqueda() {
            this.buscarCampo = null;
            this.buscarValor = '';
            this.paginaActual = 1;
            this.cargarRetiros();
        },
        onCampoChange() {
            this.buscarValor = '';
        },
        onTabChange() {
            this.paginaActual = 1;
            this.cargarRetiros();
        },
        onPaginaChange(pagina) {
            this.paginaActual = pagina;
            this.cargarRetiros();
        },
        onPorPaginaChange() {
            this.paginaActual = 1;
            this.cargarRetiros();
        },

        // ── Listados y proveedores ───────────────────────────────────────────
        async cargarListados() {
            try {
                const response = await config.listasDesplegables({ nombre_entidad: 'listados' });

                const tiposDoc = response.find(i => i.data.nombre_lista === 'Tipos_documento');
                if (tiposDoc) {
                    const map = {};
                    tiposDoc.data.rows.forEach(r => { map[r.id] = r.name; });
                    this.tiposDocMap = map;
                }

                const elementos = response.find(i => i.data.nombre_lista === 'elementos');
                if (elementos) {
                    const map = {};
                    elementos.data.rows.forEach(r => { map[r.id] = r.name; });
                    this.elementosMap = map;
                }

                const divipola = response.find(i => i.data.nombre_lista === 'divipola_colombia');
                if (divipola) {
                    const depMap = {}, munMap = {};
                    divipola.data.rows.forEach(r => {
                        depMap[r.codigo_departamento] = r.nombre_departamento;
                        munMap[r.codigo_municipio]    = r.nombre_municipio;
                    });
                    this.departamentosMap = depMap;
                    this.municipiosMap    = munMap;
                }
            } catch (e) { /* silencioso */ }
        },
        async cargarProveedores() {
            try {
                const resp = await retiroRepo.consultarProveedores();
                const opts = resp.rows.map(r => ({ value: r.data.id, text: r.data.nombre_proveedor || `Proveedor ${r.data.id}` }));
                this.listaProveedores = [{ value: null, text: 'Seleccionar proveedor...' }, ...opts];
            } catch (e) { /* silencioso */ }
        },

        // ── Acciones ─────────────────────────────────────────────────────────
        abrirAsignacion(item) {
            this.asignando = item;
            this.asignacionForm = { id_proveedor: null, observaciones: '' };
            this.modalAsignar = true;
        },
        async confirmarAsignacion(bvModalEvent) {
            bvModalEvent.preventDefault();
            if (!this.asignacionForm.id_proveedor) return;
            this.procesando = true;
            try {
                await retiroRepo.actualizarEstadoRetiro({
                    id_metadata:      this.asignando.data.id,
                    estado:           3,
                    id_proveedor:     this.asignacionForm.id_proveedor,
                    fecha_asignacion: new Date().toISOString(),
                    observaciones:    this.asignacionForm.observaciones,
                });
                this.modalAsignar = false;
                await this.cargarRetiros();
                this.cargarConteos();
                this.$bvToast.toast('Proveedor asignado exitosamente.', { title: 'Asignación', variant: 'success', solid: true });
            } catch (e) {
                this.$bvToast.toast('Error al asignar el proveedor.', { title: 'Error', variant: 'danger', solid: true });
            } finally { this.procesando = false; }
        },
        verDetalle(item) { this.seleccionado = item; this.modalDetalle = true; },

        // ── Helpers de traducción ────────────────────────────────────────────
        tipoDocNombre(id)          { return this.tiposDocMap[id]        || id || ''; },
        elementoNombre(id)         { return this.elementosMap[id]       || `Equipo ${id}`; },
        departamentoNombre(codigo) { return this.departamentosMap[codigo] || codigo || '-'; },
        municipioNombre(codigo)    { return this.municipiosMap[codigo]    || codigo || '-'; },
        nombreEstado(e)            { return ESTADOS[e]?.nombre || `Estado ${e}`; },
        estiloEstado(e)            { return ESTADOS[e]?.style  || { backgroundColor: '#6c757d', color: '#fff' }; },
        formatFecha(f) {
            if (!f) return '-';
            return new Date(f).toLocaleDateString('es-CO', { day: '2-digit', month: '2-digit', year: 'numeric' });
        },
    },
};
</script>
